import React from 'react';
import { T } from 'shared/helper/translate';
var SplitLink = function SplitLink(_ref) {
  var leftLink = _ref.leftLink,
    rightLink = _ref.rightLink,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    setShowMobileMenu = _ref.setShowMobileMenu;
  return /*#__PURE__*/React.createElement("span", {
    className: "split-link"
  }, /*#__PURE__*/React.createElement("a", {
    "aria-label": leftLink.text,
    href: leftLink.url,
    target: "_self",
    className: "dropdown-item icon-bullet-link ".concat(className),
    rel: "noreferrer",
    onClick: function onClick() {
      return setShowMobileMenu ? setShowMobileMenu(false) : null;
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: leftLink.text
  })), /*#__PURE__*/React.createElement("span", {
    className: "link-separator"
  }, " | "), /*#__PURE__*/React.createElement("a", {
    "aria-label": rightLink.text,
    href: rightLink.url,
    target: "_self",
    className: "dropdown-item icon-bullet-link ".concat(className),
    rel: "noreferrer",
    onClick: function onClick() {
      return setShowMobileMenu ? setShowMobileMenu(false) : null;
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: rightLink.text
  })));
};
export default SplitLink;